import i18n from "@/core/composables/vue-i18n";

const useTranslate = () => {
  // @ts-ignore
  const { t, n, d, getNumberFormat } = i18n.global;

  const translateWithPluralization = (key: string, count: number, params?: Record<string, unknown>): string => {
    return t(key, { count, ...params });
  };

  const translate = (key: string, params?: Record<string, unknown>): string => {
    return t(key, params ?? {});
  };

  const localizeCurrency = (value: number): string => {
    return n(value, "currency");
  };

  const localizeCurrencyWithArgs = (value: number, args: { [key: string]: string }): string => {
    return n(value, args);
  };

  const localizeDate = (value: Date, key: string = "dateTime"): string => {
    return d(value, key);
  };

  const localizeNumber = (locale: string) => {
    return getNumberFormat(locale);
  };

  return {
    translateWithPluralization,
    translate,
    localizeCurrency,
    localizeCurrencyWithArgs,
    localizeDate,
    localizeNumber,
  };
};
export default useTranslate;
